import { render, staticRenderFns } from "./proceed_detail.vue?vue&type=template&id=0e21152a&scoped=true&"
import script from "./proceed_detail.vue?vue&type=script&lang=js&"
export * from "./proceed_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e21152a",
  null
  
)

export default component.exports